import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../../Utility/API";
import { loadWeb3 } from "../../Utility/contract";
import toast from "react-hot-toast";
import "./Login.css";
import logo from "../../Assets/Images/logo.png";
import { updateAuth } from "../../Redux/AuthSlice";
import { Eye, EyeOff } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [LoginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [ipAddress, setIP] = useState("");

  const fetchIPAddress = async () => {
    try {
      const response = await axios.get("https://api64.ipify.org/?format=json");
      setIP(response.data.ip);
      return response.data.ip;
    } catch (error) {
      console.error("Error fetching IP address", error);
      toast.error("Unable to fetch IP address.");
      return null;
    }
  };

  const checkUserName = async (e) => {
    let { value } = e.target;
    const newValue = value.replace(/[^0-9]/gi, "");

    if (newValue === "") {
      setLoginId("");
    } else {
      setLoginId(newValue);
    }
  };

  const onSubmitHandler = async () => {
    const ipaddress = await fetchIPAddress();
    if (!ipaddress) return;

    if (!LoginId || !password) {
      toast.error("Please enter both username and password.");
      return;
    }

    try {
      const res = await API.post("/login", {
        username: LoginId,
        password: password,
        ipaddress: ipaddress,
      });

      console.log("res-->", res.data);

      if (res.data.data.result === "Successfull") {
        toast.success("Login successful!");
        dispatch(
          updateAuth({
            isAuth: true,
            userId: res.data.data.resultid,
            jwtToken: res.data.token,
            ipAddress: ipaddress,
          })
        );

        // if (res.data.data.plan_id === "2") {
        //   // MAGIC PLAN
        //   navigate("/Dashboard");
        // } else if (res.data.data.plan_id === "1") {
        //   // fix plan
        //   navigate("/Dashboard");
        // } else if (res.data.data.plan_id === "0") {
        //   // plan check
        //   navigate("/PlanCheck");
        // }

        navigate("/DashboardSelect");
      } else {
        toast.error("Invalid username or password.");
      }
    } catch (error) {
      console.error("Login API Error", error);
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <>
      <div className="container-fluid loginpage vh-100">
        <div className="row h-100 align-items-center">
          <div className="col-md-4 col-sm-6 col-12 h-100 d-flex justify-content-center align-items-center h-100 flex-column  mx-auto mt-4 mt-sm-0">
            <div className="mt-5 mt-sm-0">
              <div className="card cardlogin position-relative mt-5 mt-sm-0">
                <div className="card-body p-0">
                  <div className="row mx-0 gy-2 h-100 g-3 ">
                    <div className="col-12">
                      <div className="loginheading text-center">
                        <img src={logo} />
                      </div>
                      {/* <div className="loginheading text-center">
                        Welcome Back
                      </div>
                      <div className="loginheading2 text-center">
                        Please Login to Your Account
                      </div>
                      <div className="subtext text-center text-capitalize">
                        {" "}
                        Remember to authorize with the correct Id & Password.
                      </div> */}
                    </div>
                    <div className="col-12">
                      <label htmlFor="userInput">Please Enter ID</label>
                      {/* <input
                        type="text"
                        placeholder="Enter your ID or  BNB Address"
                        id="userInput"
                        className="control-form mb-2"
                        // value={LoginId}
                        // onChange={(e) => setLoginId(e.target.value)}
                      readOnly
                      /> */}
                      <input
                        type="text"
                        className="control-form"
                        id="userInput"
                        placeholder="Enter Your ID"
                        maxLength={6}
                        value={LoginId}
                        onChange={(e) => {
                          checkUserName(e);
                        }}
                      />
                    </div>
                    <div className="col-12">
                      <label htmlFor="userPassword">
                        Please Password
                        <button
                          type="button"
                          className="absolute eyebtn right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                          onClick={togglePasswordVisibility}
                          aria-label={
                            showPassword ? "Hide password" : "Show password"
                          }>
                          {showPassword ? (
                            <EyeOff size={15} />
                          ) : (
                            <Eye size={15} />
                          )}
                        </button>
                      </label>
                      <div className="d-flex">
                        <div className="col-12">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="control-form regpassinp"
                            name="password"
                            id="userPassword"
                            required="required"
                            placeholder="Enter Password"
                            maxLength={20}
                            onChange={(e) => {
                              setPassword(e.target.value);
                            }}></input>
                        </div>
                        {/* <div className="col-1">
                          <span className="position-absolute eye">
                            <i className="fa fa-eye text-black eye" />
                          </span>
                        </div> */}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="remembertext text-end">
                        <Link className="Anker" to="/Forgotpassword">
                          {" "}
                          Forgot Password{" "}
                        </Link>
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn logibtn newcolor px-4"
                        onClick={() => {
                          onSubmitHandler();
                        }}>
                        {/* <
                          className="Anker"
                         
                          onClick={() => {
                            onSubmitHandler();
                          }}> */}
                        Login
                        {/* </> */}
                      </button>
                    </div>

                    <div className="col-12">
                      <div className="remembertext text-center">
                        Don’t have an account?{" "}
                        <Link className="Anker" to="/register">
                          {" "}
                          Create Account{" "}
                        </Link>
                      </div>
                      <div className="bottomtext">
                        Copyright © 2024. All Rights Reserved.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
